module.exports = __WEBPACK_EXTERNAL_MODULE_20__;


//////////////////
// WEBPACK FOOTER
// external {"amd":"openfl/utils/ByteArray","root":["openfl","utils","ByteArray"],"commonjs":"openfl/utils/ByteArray","commonjs2":"openfl/utils/ByteArray"}
// module id = 20
// module chunks = 0